import { render, staticRenderFns } from "./orderWD.vue?vue&type=template&id=773ba7c2&scoped=true"
import script from "./orderWD.vue?vue&type=script&lang=js"
export * from "./orderWD.vue?vue&type=script&lang=js"
import style0 from "./orderWD.vue?vue&type=style&index=0&id=773ba7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ba7c2",
  null
  
)

export default component.exports